import { createAction } from "@reduxjs/toolkit";

export const AddFilterKPIConsultants = createAction('filterKPIConsultants/add');
export const AddPlaqueDateFilterKPIConsultants = createAction('filterKPIConsultants/addPlaque');
export const AddSelectedConsultantsFilterKPIConsultants = createAction('filterKPIConsultants/addSelectedConsultant');
export const LoadAllFilterKPIConsultants = createAction('filterKPIConsultants/load');
export const ClearListFilterKPIConsultants = createAction('filterKPIConsultants/clear');

